import { WriteBackProvider } from '../types';

/**
 * Formats a facility for display in writeback notes
 * Similar to WriteBacks.formatProvider but for facilities
 */
export const formatFacility = (facility: WriteBackProvider): string => {
  const { npi, organizations } = facility;
  const organization = organizations?.[0];
  const name = organization?.name || '';
  const address = organization?.address?.fullAddress || '';
  const phone = organization?.contact_info?.mobilePhoneNumber || '';

  return [name, npi ? `NPI: ${npi}` : '', address, phone ? `Phone: ${phone}` : '']
    .filter(Boolean)
    .join('\n');
};
